import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NewNodalOfficerDashboardModel } from '../model/NewNodalOfficerDashboardModel';
import { NewNodalOfficerDashboardLotterywiseModel } from '../model/NewNodalOfficerDashboardLotterywiseModel';
import { NewNodalOfficerDashboardSchemewiseModel } from '../model/NewNodalOfficerDashboardSchemewiseModel';
import { PendencyDashboardModel } from '../model/PendencyDashboardModel';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

  fetchNodalOfficerDashboard(lotetryFilter?: string ) {
    let reqParams =
    
    (lotetryFilter ? `&insPaymentFilter=${lotetryFilter}` : "");

    return this.httpClient.get<NewNodalOfficerDashboardModel>(ApiUrls.dashboard);
  }

  // fetchLotteryWiseDashboard(lotteryKey?: number ) {
  //   let reqParams =
    
  //   (lotteryKey ? `&lotteryKey=${lotteryKey}` : "");

  //   return this.httpClient.get<NewNodalOfficerDashboardModel>(ApiUrls.dashboard);
  // }

  fetctPendancyCountDashboard(lotetryFilter?: string ) {
    let reqParams =
    
    (lotetryFilter ? `&insPaymentFilter=${lotetryFilter}` : "");

    return this.httpClient.get<PendencyDashboardModel>(ApiUrls.countDashboard);
  }

   fetchLotteryWiseDashboard(lotteryKey: number) {
    return this.httpClient.get<NewNodalOfficerDashboardLotterywiseModel>(ApiUrls.lotterywisedashboard.replace('{lotteryKey}', lotteryKey.toString()));
   }

   fetchSchemeWiseDashboard(schemekey: number) {  
    return this.httpClient.get<NewNodalOfficerDashboardSchemewiseModel>(ApiUrls.schemewisedashboard.replace('{schemekey}', schemekey.toString()));
   }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
}
